<template>
  <component :is="layout">
    <router-view />
  </component>
</template>

<script>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

export default{
  setup(){
    let { currentRoute } = useRouter();
    let layout = computed( () => `${currentRoute.value.meta.layout}-layout`)
    

    return { layout }
  }
}

</script>
<style>
.divider:after,
.divider:before {
  content: "";
  flex: 1;
  height: 1px;
  background: #eee;
}

.h-custom {
  height: calc(100% - 73px);
}

@media (max-width: 450px) {
  .h-custom {
    height: 100%;
  }
}
</style>